// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3xoDj","log":"ModalInventoryLogs_log__uVsaX","date":"ModalInventoryLogs_date__3Iaop","userName":"ModalInventoryLogs_userName__gOiH6"};